<template>
    <!-- ROOMS -->
    <div id="room-list">
        <h2 class="pb-4 font-weight-bold">
            {{ $t('sidebar.rooms') }}
        </h2>
        <v-list dense>
            <v-list-item
                v-show="rooms[roomIndex].items && rooms[roomIndex].hasCombination"
                v-for="(room, roomIndex) in rooms"
                :key="`room-${roomIndex}`"
                :ripple="false"
                :class="{ 'active': room.active }"
                @click.prevent="selectRoom(room)"
            >
                <v-list-item-icon class="my-0 mr-4"
                    :class="{
                        'mt-2 ': isAlternativeMode
                    }"
                >
                    <v-icon class="room-icon icon">
                        {{ getPictoByType(room.type) }}
                    </v-icon>
                </v-list-item-icon>
                <v-list-item-content class="room-title">
                    <v-list-item-title
                        class="habiteo-body-2 text-none"
                        :class="{ 'active': room.active }"
                        v-text="room.name"
                    />
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
    <!-- /ROOMS -->
</template>

<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'Rooms',
        props: {
            rooms: {
                type: Array,
                required: true,
            }
        },
        computed: {
            ...mapGetters(['isAlternativeMode']),
        },
        methods: {
            selectRoom(room) {
                this.$emit('select-room', room);
            },
            getPictoByType(typology) {
                let roomItemClass = null;
                switch (typology) {
                    // case '':
                    //     roomItemClass = 'bathroom';
                    //     break;
                    // case '':
                    //     roomItemClass = 'shower-room';
                    //     break;
                    // case '':
                    //     roomItemClass = 'bedroom';
                    //     break;
                    // case '':
                    //     roomItemClass = 'office';
                    //     break;
                    // case '':
                    //     roomItemClass = 'balcony';
                    //     break;
                    // case '':
                    //     roomItemClass = 'kitchen';
                    //     break;
                    case 'dressing':
                        roomItemClass = 'dressing-room';
                        break;
                    case 'pathway':
                    case 'lobby':
                        roomItemClass = 'corridor';
                        break;
                    case 'bedroom-teen':
                    case 'bedroom-child':
                    case 'secondary-bedroom':
                        roomItemClass = 'bedroom';
                        break;
                    case 'living-room-kitchen':
                    case 'living-room-lounge':
                        roomItemClass = 'living-room';
                        break;
                    case 'rest-room':
                        roomItemClass = 'wc';
                        break;
                    case 'bedroom-suite':
                        roomItemClass = 'adult-room';
                        break;
                    default:
                        roomItemClass = typology;
                        break;
                }
                return `icon-${roomItemClass}`;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .room-title {
        text-overflow: ellipsis;
        -webkit-box-align: start;
        align-self: center;
    }
</style>


// WEBPACK FOOTER //
// src/layout/sidebar/configurableTour/components/Rooms.vue